import React, { useState, useEffect, useRef } from 'react';
import './App.css';


const slides = [
    { src: '/assets/Verified_latest.png', alt: 'QRmor original scan verified vs duplicate scan detected' },
    { src: '/assets/NotVerified_latest.png', alt: 'QRmor authentication dashboard showing total authentications, alerts, and device breakdown' }
];

const SLIDE_DURATION = 2000; // ms per slide

export default function HeroShowcase() {
    const [active, setActive] = useState(0);
    const [paused, setPaused] = useState(false); // ADDED
    const timerRef = useRef(null);

    useEffect(() => {
        if (paused) return; // ADDED
        timerRef.current = setInterval(() => {
            setActive((prev) => (prev + 1) % slides.length);
        }, SLIDE_DURATION);
        return () => clearInterval(timerRef.current);
    }, [active, paused]); // paused ADDED to deps

    function handleDotClick(index) {
        clearInterval(timerRef.current);
        setActive(index);
    }

    return (
        <div
            className="hero-showcase"
            onMouseEnter={() => setPaused(true)} // ADDED
            onMouseLeave={() => setPaused(false)} // ADDED
        >
            {slides.map((slide, i) => (
                <img
                    key={slide.src}
                    src={slide.src}
                    alt={slide.alt}
                    className={`hero-showcase-img ${i === active ? 'is-active' : ''}`}
                />
            ))}
            <div className="hero-showcase-dots">
                {slides.map((_, i) => (
                    <button
                        key={i}
                        className={`hero-showcase-dot ${i === active ? 'is-active' : ''}`}
                        onClick={() => handleDotClick(i)}
                        aria-label={`Show slide ${i + 1}`}
                    />
                ))}
            </div>
        </div>
    );
}